import { RouterProvider } from 'react-router-dom';
import './App.css';
import router from './Router/Routes/Routes';

function App() {



  return (
    <div data-theme="cupcake" className='max-w-screen-xl mx-auto rounded'>
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
